import { Component, OnInit } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { faFileContract} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-fiverings',
  templateUrl: './fiverings.component.html',
  styleUrls: ['./fiverings.component.scss']
})
export class FiveRingsComponent implements OnInit {

    public latitude: Number;
    public longitude: Number;
    public zoom: Number;
    public faFileAlt = faFileContract;

  constructor(private router: Router, private http : HttpClient) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.latitude = 12.7993637;
    this.longitude = 77.7265857;
    this.zoom = 12;
  }

 
}
